import React, { Component }  from 'react';
import { Card, CardContent, Button } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from "react-router-dom";
const { t } = useTranslation();

class Order extends Component {
    render() {
        return (
            <Card className="OrderCard">
                <CardContent>
                    <div className="statusLabelContainer">
                        <span className="statusLabel fullWidth" style={{bordercolor: this.props.statusForeground, color: this.props.statusBackground}} x-ms-format-detection="none">{this.props.statusName}</span>
                    </div>
                    <p><Trans>{t('OrderNumber')}</Trans> : {this.props.productCode}</p>
                    <p><Trans>{t('Project')}</Trans> : {this.props.project}</p>
                    <p><Trans>{t('Customer')}</Trans> : {this.props.customer}</p>
                    <p><Trans>{t('Material')}</Trans> : {this.props.material}</p>
                    <p><Trans>{t('RegisteredTime')}</Trans> : {this.props.elapsedProductionTime}</p>
                    
                    <Link to={`/order/${encodeURIComponent(this.props.productCode)}/${encodeURIComponent(this.props.id)}`}>
                        <Button className="OrderEditBtn" color="secondary" variant="contained">{this.props.editTitle}</Button>
                    </Link>
                </CardContent>
            </Card>
        )
    }
}

export default Order;